import './BeautifulWorker.less'
import useHistory from '@/hooks/useHistory'



const BeautifulWorker = () => {
  const history = useHistory()
  const toDetail = (val) => {
    history.push('/WorkerMienDetail?id=0' + val, 'route')
  }

  return (
    <div className="pg-beautiful-worker">
      <div className='header-wrap'>
        <img src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/beautifulWorker/header.png' />
      </div>
      <div className='container'>
        {
          [16,13,12,14,11,15].map((item, index) => {
            return <img 
              key={item} 
              className='item-img' 
              src={`https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/beautifulWorker/list-0${index + 1}.png`} 
              onClick={() => toDetail(item)}
            />
          })
        }
      </div>
    </div>
  )
}

export default BeautifulWorker